import { render, staticRenderFns } from "./CoreSelectClient.vue?vue&type=template&id=349cfbc4&scoped=true"
import script from "./CoreSelectClient.vue?vue&type=script&lang=js"
export * from "./CoreSelectClient.vue?vue&type=script&lang=js"
import style0 from "./CoreSelectClient.vue?vue&type=style&index=0&id=349cfbc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349cfbc4",
  null
  
)

export default component.exports